<template>
    <div :class="['soli-grey', 'body-1']">
        {{ title }}
    </div>
</template>

<script>
export default {
    props: {
        attendance: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        title() {
            if (this.attendance.group_event_title) {
                let eventName = this.attendance.lesson.group_event.title;
                return this.attendance.reschedule_id
                    ? `${eventName} Reschedule`
                    : eventName;
            }

            return `${this.attendance.lesson.instrument.name} ${this.attendance.lesson.type}`;
        },
    },
};
</script>
